import axios from 'axios';
import api from 'api';
import { apiInstance } from 'api/utils';

const recommendationApi = {
  evaluate: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/evaluate/`
    });
  },
  getRecommendationsData: ({ portfolio }: { portfolio: any }) =>
    axios.all([
      api.getExistingPolicies({ portfolio }),
      api.getContributions({ portfolio }),
      api.getPolicies({ portfolio }),
      api.getContributionsSummary({ portfolio })
    ])
};

export default {
  ...recommendationApi
};
